import { useBlinkContextWithValidation, } from '@thoughtspot/blink-context';
import { useEffect } from 'react';
const GLOBAL_NAV_CUSTOM_STYLING_SERVICE_CONTRACT = [
    { propName: 'getConfig', propType: 'function' },
];
const GLOBAL_NAV_METRICS_SERVICE_CONTRACT = [
    { propName: 'collectEvent', propType: 'function' },
];
const GLOBAL_NAV_NAV_SERVICE_CONTRACT = [
    { propName: 'goToHome', propType: 'function' },
    { propName: 'goToAnswer', propType: 'function' },
    { propName: 'getSubDomainIfOrgEnabled', propType: 'function' },
    { propName: 'openExternalUrlInNewTab', propType: 'function' },
];
const GLOBAL_NAV_SESSION_SERVICE_CONTRACT = [
    { propName: 'getReleaseVersion', propType: 'function' },
    { propName: 'getBaseReleaseVersion', propType: 'function' },
    { propName: 'getCurrentOrgId', propType: 'function' },
    { propName: 'getHelpConfig', propType: 'function' },
    { propName: 'getSupportConfigItems', propType: 'function' },
    { propName: 'isOrgUiEnabled', propType: 'function' },
    { propName: 'areProfileAndHelpHidden', propType: 'function' },
    { propName: 'isApplicationSwitcherHidden', propType: 'function' },
    { propName: 'isOrgSwitcherHidden', propType: 'function' },
    { propName: 'getOnlineDocUrl', propType: 'function' },
    { propName: 'getInAppHelpUrl', propType: 'function' },
    { propName: 'isSaaSCluster', propType: 'function' },
    { propName: 'isReactshellEnabled', propType: 'function' },
    { propName: 'isModularHomeExperienceEnabled', propType: 'function' },
    { propName: 'isOrgPerUrlEnabled', propType: 'function' },
    { propName: 'hideOrgSwitcherUi', propType: 'function' },
    {
        propName: 'isEnableSelectiveUserAccessRestriction',
        propType: 'function',
    },
    {
        propName: 'showOrgSwitcherToUsersWithMultipleOrgs',
        propType: 'function',
    },
];
const GLOBAL_NAV_SYSTEM_CONFIG_SERVICE_CONTRACT = [
    { propName: 'isIntercomEnabled', propType: 'function' },
];
const GLOBAL_NAV_OBSERVABILITY_SERVICE_CONTRACT = [
    { propName: 'watchForFullReplay', propType: 'function' },
    { propName: 'stopReplay', propType: 'function' },
];
export const useBlinkContextForGlobalNav = () => {
    const [validate, blinkContext] = useBlinkContextWithValidation({
        customStylingServiceContract: GLOBAL_NAV_CUSTOM_STYLING_SERVICE_CONTRACT,
        metricsServiceContract: GLOBAL_NAV_METRICS_SERVICE_CONTRACT,
        navServiceContract: GLOBAL_NAV_NAV_SERVICE_CONTRACT,
        sessionServiceContract: GLOBAL_NAV_SESSION_SERVICE_CONTRACT,
        systemConfigServiceContract: GLOBAL_NAV_SYSTEM_CONFIG_SERVICE_CONTRACT,
        observabilityServiceContract: GLOBAL_NAV_OBSERVABILITY_SERVICE_CONTRACT,
    });
    return blinkContext;
};
export const useValidateBlinkContextForGlobalNav = () => {
    const [validate] = useBlinkContextWithValidation({
        customStylingServiceContract: GLOBAL_NAV_CUSTOM_STYLING_SERVICE_CONTRACT,
        metricsServiceContract: GLOBAL_NAV_METRICS_SERVICE_CONTRACT,
        navServiceContract: GLOBAL_NAV_NAV_SERVICE_CONTRACT,
        sessionServiceContract: GLOBAL_NAV_SESSION_SERVICE_CONTRACT,
        systemConfigServiceContract: GLOBAL_NAV_SYSTEM_CONFIG_SERVICE_CONTRACT,
        observabilityServiceContract: GLOBAL_NAV_OBSERVABILITY_SERVICE_CONTRACT,
    });
    useEffect(() => {
        validate('GLOBAL_NAV');
    }, [validate]);
};
//# sourceMappingURL=global-nav-blink-context.js.map